import styled from 'styled-components'

import {
    ColumnFlex,
    FlexAlignItemsCenter,
} from 'components/common/genericStyles'

export const Container = styled.div`
    width: 100%;
    height: 100%;
    ${ColumnFlex}
    justify-content: flex-end;
    cursor: default;
`

export const Wrapper = styled.div`
    padding: 10px 12px;
    overflow: hidden auto;
`

export const AvatarWrapper = styled.div`
    height: 20px;
    width: 20px;
`

export const Identity = styled.div`
    ${FlexAlignItemsCenter}
    ${props =>
        props.isLocal && `justify-content: flex-end;`}
    height: max-content;
    & > span {
        margin: 0px 8px;
    }
`
